/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

$(document).ready(function () {

    if ($(".at-share-btn.at-svc-facebook").length > 0) {
        $(".at-share-btn.at-svc-facebook").bind("click", function () {

            dataLayer.push({
                'event': 'social-int',
                'action': 'share',
                'label': 'Facebook',
                'url': 'www.tena.com'
            });
        });
    }
    if ($(".at-share-btn.at-svc-twitter").length > 0) {
        $(".at-share-btn.at-svc-twitter").bind("click", function () {

            dataLayer.push({
                'event': 'social-int',
                'action': 'share',
                'label': 'Twitter',
                'url': 'www.tena.com'
            });
        });
    }
    if ($(".at-share-btn.at-svc-email").length > 0) {
        $(".at-share-btn.at-svc-email").bind("click", function () {
            dataLayer.push({
                'event': 'social-int',
                'action': 'share',
                'label': 'email',
                'url': 'www.tena.com'
            });
        });
    }
    if ($(".at-share-btn.at-svc-print").length > 0) {
        $(".at-share-btn.at-svc-print").bind("click", function () {
            dataLayer.push({
                'event': 'social-int',
                'action': 'share',
                'label': 'print',
                'url': 'www.tena.com'
            });
        });
    }

    if ($(".menu-item.has-submenu.logged-in").length > 0) {
        $(".menu-item.has-submenu.logged-in").bind("click", function () {

            dataLayer.push({
                'event': 'login-link',
                'action': 'click'
            });
        });
    }
    $(".btn-play-wrapper a[href]").each(function () {


        if ($(".btn-play-wrapper").length > 0) {
            var href1 = $(this).attr('href');

            $(".jw-video-popup").bind("click", function () {
                dataLayer.push({
                    'event': 'video',
                    'action': 'play',
                    'label': href1
                });
            });
        }
    });
    if ($(".pushbox-play-btn").length > 0) {
        var href2 = $(".pushbox-play-btn a").attr('href');

        $(".jw-video-popup").bind("click", function () {
            dataLayer.push({
                'event': 'video',
                'action': 'play',
                'label': href2
            });
        });
    }
    if ($(".video-play-btn").length > 0) {
        var href3 = $(".video-play-btn a").attr('href');

        $(".jw-video-popup").bind("click", function () {
            dataLayer.push({
                'event': 'video',
                'action': 'play',
                'label': href3
            });
        });
    }


        $.each($.find('[data-query-value]'), function (key, value) {
            var qryValue = $(this).attr('data-query-value');
            var qryKey = $(this).attr('data-query-key');
            var anchorhref = $(this).attr('href');
            anchorhref = anchorhref.replace(".aspx", "/");
            if (qryValue !== '' && qryKey !== '' && anchorhref !== '') {
                var finalURL = anchorhref + qryValue;
                $(this).attr('href', finalURL);
            }
        });


    $(".popup-share-link-pair-container").click(function () {
        var e = $(this).find("a").attr("href"),
            t = $(this).find(".text-link").text();

        return dataLayer.push({
            event: "social-int",
            action: "share",
            label: t,
            url: e
        }), ShareThis(this), !1;
    });


});



    function CallGA(ProductName) {
        dataLayer.push ({
            'event': 'product',
            'label': 'product-details',
            'action': 'button - click',
            'name': ProductName
        });
    }


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/datalayer.min.js